export const ACCOUNT_DEPOSIT = "App\\Models\\AccountDeposit";
export const MILESTONE = "App\\Models\\Milestone";
export const ACCOUNT_TRANSFER = "App\\Models\\AccountTransfer";
export const EXPENSE = "App\\Models\\Expense";
